/* istanbul ignore file */
// Generated code for Big.Webservice.Controllers.BigLoginController.
// Edit _ApiService.tst to change the generated output.
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { ZorroApiClient } from '../zorro-api-client';

import { ChangePasswordByTokenRequest } from '../models/change-password-by-token-request';
import { ChangePasswordRequest } from '../models/change-password-request';
import { CreateAccountRequest } from '../models/create-account-request';
import { RequestAlterAccountTokenRequest } from '../models/request-alter-account-token-request';
import { ResetPasswordRequest } from '../models/reset-password-request';
import { TokenRequest } from '../models/token-request';
import { TokenResponse } from '../models/token-response';

@Injectable()
export class BigLoginApiService extends ZorroApiClient {

    constructor(
      private readonly httpClient: HttpClient
    ) {
        super();
    }


    public createAccount(data: CreateAccountRequest, spinnerMessage: string = null): Observable<void> {
        return this.httpClient.post<void>(`/api/biglogin/createaccount`, data,
        {params: this.createOptions(null, spinnerMessage)}); // tslint:disable-line //NOSONAR
    }

    public resetPassword(data: ResetPasswordRequest, spinnerMessage: string = null): Observable<void> {
        return this.httpClient.post<void>(`/api/biglogin/resetpwd`, data,
        {params: this.createOptions(null, spinnerMessage)}); // tslint:disable-line //NOSONAR
    }

    public validateResetPasswordToken(data: TokenRequest, spinnerMessage: string = null): Observable<TokenResponse> {
        return this.httpClient.post<TokenResponse>(`/api/biglogin/resetpwd/validatetoken`, data,
        {params: this.createOptions(null, spinnerMessage)}); // tslint:disable-line //NOSONAR
    }

    public changePasswordByToken(data: ChangePasswordByTokenRequest, spinnerMessage: string = null): Observable<void> {
        return this.httpClient.post<void>(`/api/biglogin/resetpwd/changepassword`, data,
        {params: this.createOptions(null, spinnerMessage)}); // tslint:disable-line //NOSONAR
    }

    public changePassword(data: ChangePasswordRequest, spinnerMessage: string = null): Observable<void> {
        return this.httpClient.post<void>(`/api/biglogin/changepassword`, data,
        {params: this.createOptions(null, spinnerMessage)}); // tslint:disable-line //NOSONAR
    }

    public enable(data: TokenRequest, spinnerMessage: string = null): Observable<void> {
        return this.httpClient.post<void>(`/api/biglogin/enable`, data,
        {params: this.createOptions(null, spinnerMessage)}); // tslint:disable-line //NOSONAR
    }

    public requestAlterAccount(data: RequestAlterAccountTokenRequest, spinnerMessage: string = null): Observable<void> {
        return this.httpClient.post<void>(`/api/biglogin/requestalteraccount`, data,
        {params: this.createOptions(null, spinnerMessage)}); // tslint:disable-line //NOSONAR
    }

    public alterAccount(data: TokenRequest, spinnerMessage: string = null): Observable<void> {
        return this.httpClient.post<void>(`/api/biglogin/alteraccount`, data,
        {params: this.createOptions(null, spinnerMessage)}); // tslint:disable-line //NOSONAR
    }

}
